import { styled } from 'baseui';
const QuestionList = styled('ul', {
  padding: 0,
  margin: 0
});
export default QuestionList;